import React, { FC, useEffect, useState } from "react";
import Label, { LabelTone } from "../../components/Label";
import Text, { TextTone } from "../../components/Text";

export interface TOCItem {
  url: string;
  title: string;
}

interface IPostTocProps {
  contents: TOCItem[];
}

const PostToc: FC<IPostTocProps> = ({ contents }) => {
  const [currentHeadingId, setCurrentHeadingId] = useState<string>();

  useEffect(() => {
    const headings = contents?.map((heading) => ({ ...heading, visible: false }));

    // Observe headings intersecting with the viewport
    const headingObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const currentId = `#${entry.target.id}`;
        const currentHeading = headings.find((heading) => heading.url === currentId);
        currentHeading.visible = entry.isIntersecting;
      });

      // Set the first visible heading as the current heading
      const visibleHeadings = headings.filter((heading) => heading.visible);
      setCurrentHeadingId(visibleHeadings[0]?.url);
    });

    contents?.forEach((heading) => {
      const element = document.querySelector(heading.url);

      if (element) {
        headingObserver.observe(element);
      }
    });

    return () => {
      headingObserver.disconnect();
    };
  }, [contents]);

  if (!contents) return null;

  return (
    <div className="kld-post-toc">
      <Label className="kld-post-toc__label" id="toc-label" as="span" tone={LabelTone.Secondary}>
        Contents
      </Label>
      <nav className="kld-post-toc__nav" aria-labelledby="toc-label">
        {contents?.map(({ url, title }) => (
          <a className="kld-post-toc__link" key={url} href={url} aria-current={currentHeadingId === url}>
            <Text truncate tone={TextTone.Auto}>
              {title}
            </Text>
          </a>
        ))}
      </nav>
    </div>
  );
};

export default PostToc;
